/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
/* eslint-disable react/no-unknown-property */
import React, { useEffect, useState } from 'react';
import { Typography, Modal, Row, Col, message, Button, Descriptions, Tag, Avatar } from 'antd';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { API_ENDPOINT, BLOOD_GROUPS, EMPLOYEE_TYPE, GENDERS } from '../../../config/config';
import ImagePreview from '../image-preview';

const { Text, Title } = Typography;

const DetailsDialog = ({ showDialog, isEdit = false, editId }) => {
  const [busy, setBusy] = useState(true);
  const [profilePicture, setProfilePicture] = useState(null);
  const [employeeData, setEmployeeData] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const fetchEmployeeData = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/common/emp/get-by-id', { id });
      if (response.data.status) {
        const { data } = response.data;
        setEmployeeData({
          ...data,
          date_of_birth: data.date_of_birth ? moment(data.date_of_birth).format('D MMM YYYY') : 'N/A',
          blood_group: BLOOD_GROUPS.find((group) => group.id === Number(data.blood_group_id))?.label || 'N/A',
          gender: GENDERS.find((gender) => gender.id === Number(data.gender_id))?.label || 'N/A',
          designation: data.desig_title,
          emp_type: EMPLOYEE_TYPE.find((type) => type.id === Number(data.emp_type))?.label || 'N/A',
          is_biometric_verified: Number(data.is_biometric_verified) === 1 ? 'Verified' : 'Not Verified',
          is_police_verified: Number(data.is_police_verified) === 1 ? 'Verified' : 'Not Verified',
          registration_date: data.created_at ? moment(data.created_at).format('DD/MM/YYYY hh:mm a') : 'N/A',
          last_updated: data.updated_at ? moment(data.updated_at).format('DD/MM/YYYY hh:mm a') : 'N/A',

          isBMV: Number(data.is_biometric_verified) === 1 || false,
          isPV: Number(data.is_police_verified) === 1 || false,
        });
        setProfilePicture(data.profile_picture ? `${API_ENDPOINT}/${data.profile_picture}` : null);
      } else {
        message.error(response.data.message || response.message);
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching employee data:', error);
      message.error(error.message);
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchEmployeeData(editId);
    }
  }, [isEdit, editId]);

  if (!employeeData) return null;

  const getEmploymentStatus = () => {
    if (employeeData.is_employeed === 1) {
      return { text: 'Working', color: 'green' };
    }
    return { text: 'Fired', color: 'red' };
  };

  const getActiveStatus = () => {
    if (employeeData.is_active) {
      return { text: 'Active', color: 'green' };
    }
    return { text: 'Inactive', color: 'red' };
  };

  const getTrainedStatus = () => {
    if (employeeData.is_trained) {
      return { text: 'Trained', color: 'green' };
    }
    return { text: 'Not Trained', color: 'orange' };
  };

  const getFaceClearedStatus = () => {
    if (employeeData.is_face_cleared === 1) {
      return { text: 'Cleared', color: 'green' };
    }
    return { text: 'Not Cleared', color: 'red' };
  };

  const employmentStatus = getEmploymentStatus();
  const activeStatus = getActiveStatus();
  const trainedStatus = getTrainedStatus();
  const faceClearedStatus = getFaceClearedStatus();

  return (
    <Modal
      open
      title='Employee Details'
      okText='Close'
      cancelText='Close'
      width='80%'
      centered
      confirmLoading={busy}
      footer={[
        <Button key="cancel" onClick={() => showDialog(false)} disabled={busy}>
          Close
        </Button>
      ]}
      onCancel={() => showDialog(false)}
    >


      {/* Enlarged Image Modal */}
      <ImagePreview
        visible={isImageModalOpen}
        imageSrc={profilePicture}
        onClose={() => setIsImageModalOpen(false)}
      />

      {/* Profile Picture Section */}
      <div className="flex justify-center mb-6">
        <style jsx>{`
          .company-info .ant-descriptions-item-content {
            font-weight: 00 !important;
            font-size: 14px !important;
            color: #000000 !important;
          }
          
          .company-info .ant-descriptions-item-label {
            font-weight: 400 !important;
            font-size: 13px !important;
            color:rgb(101, 104, 110) !important;
          }
          
          .company-info .ant-tag {
            font-weight: 600 !important;
            font-size: 12px !important;
            padding: 4px 12px !important;
            border-radius: 6px !important;
            height: auto !important;
            line-height: 1.4 !important;
          }
          
          .company-info .ant-descriptions-item-content .ant-tag {
            font-weight: 600 !important;
            font-size: 12px !important;
            padding: 4px 12px !important;
            border-radius: 6px !important;
            height: auto !important;
            line-height: 1.4 !important;
          }
          
        `}</style>

        <Avatar
          src={profilePicture || require('../../../static/img/avatar/profileImage.png')}
          size={120}
          className="cursor-pointer hover:scale-105 transition-transform duration-200"
          onClick={() => {
            if (profilePicture) setIsImageModalOpen(true);
          }}
        />
      </div>

      {/* Employee Details using Descriptions */}
      <div className="company-info">


        <Descriptions
          title="Personal Information"
          bordered
          column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
          size="middle"
          className="mb-6"
        >
          <Descriptions.Item label="Name" span={1}>
            <Text strong>{employeeData.name || 'N/A'}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Father's Name" span={1}>
            <Text strong>{employeeData.father_name || 'N/A'}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="CNIC" span={1}>
            <Text strong>{employeeData.cnic || 'N/A'}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Contact" span={1}>
            <Text strong>{employeeData.contact || 'N/A'}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Date of Birth" span={1}>
            <Text strong>{employeeData.date_of_birth}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Gender" span={1}>
            <Text strong>{employeeData.gender}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Blood Group" span={1}>
            <Text strong>{employeeData.blood_group}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Designation" span={1}>
            <Text strong>{employeeData.designation}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Employee Type" span={1}>
            <Text strong>{employeeData.emp_type}</Text>
          </Descriptions.Item>
        </Descriptions>

        <Descriptions
          title="Company Information"
          bordered
          column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
          size="middle"
          className="mb-6"
        >
          <Descriptions.Item label="Company Name" span={2}>
            <Text strong>{employeeData.comp_name || 'N/A'}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Company ID" span={1}>
            <Text strong>{employeeData.comp_id || 'N/A'}</Text>
          </Descriptions.Item>
        </Descriptions>

        <Descriptions
          title="Status Information"
          bordered
          column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
          size="middle"
          className="mb-6"
        >
          <Descriptions.Item label="Employment Status" span={1}>
            <Tag color={employmentStatus.color}>{employmentStatus.text}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Active Status" span={1}>
            <Tag color={activeStatus.color}>{activeStatus.text}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Training Status" span={1}>
            <Tag color={trainedStatus.color}>{trainedStatus.text}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Face Cleared" span={1}>
            <Tag color={faceClearedStatus.color}>{faceClearedStatus.text}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="NADRA Verified" span={1}>
            <Tag color={employeeData.isBMV ? 'green' : 'red'}>
              {employeeData.is_biometric_verified}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Police Verified" span={1}>
            <Tag color={employeeData.isPV ? 'green' : 'red'}>
              {employeeData.is_police_verified}
            </Tag>
          </Descriptions.Item>
        </Descriptions>

        <Descriptions
          title="Timeline Information"
          bordered
          column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
          size="middle"
          className="mb-6"
        >
          <Descriptions.Item label="Registration Date" span={1}>
            <Text strong>{employeeData.registration_date}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Last Updated" span={1}>
            <Text strong>{employeeData.last_updated}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="End Date" span={1}>
            <Text strong>{employeeData.end_date ? moment(employeeData.end_date).format('DD/MM/YYYY') : 'N/A'}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="End Remarks" span={2}>
            <Text strong>{employeeData.end_remarks || 'N/A'}</Text>
          </Descriptions.Item>
        </Descriptions>

        {employeeData.card_picture && (
          <Descriptions
            title="Card Information"
            bordered
            column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
            size="middle"
          >
            <Descriptions.Item label="Card Picture" span={3}>
              <Avatar
                src={`${API_ENDPOINT}/${employeeData.card_picture}`}
                size={80}
                className="cursor-pointer hover:scale-105 transition-transform duration-200"
                onClick={() => {
                  setProfilePicture(`${API_ENDPOINT}/${employeeData.card_picture}`);
                  setIsImageModalOpen(true);
                }}
              />
            </Descriptions.Item>
          </Descriptions>
        )}
      </div>
    </Modal>
  );
};

export default DetailsDialog;
